export default "__VITE_ASSET__DwAHGWuT__"